import { Service } from '@/services/api';
import type { SavedPolicyFilter, SavedPolicyFilterPayload } from '@/types/v2/SavedPolicyFilter';

class SavedPolicyFilterService extends Service {
  async list(): Promise<SavedPolicyFilter[]> {
    return this.get<SavedPolicyFilter[]>('/v1/saved-policy-filter').then(this.handleResponse);
  }

  async create(payload: SavedPolicyFilterPayload): Promise<void> {
    return this.post<void>('/v1/saved-policy-filter', payload).then(this.handleResponse);
  }

  async update(id: number, payload: SavedPolicyFilterPayload): Promise<void> {
    return this.patch<void>(`/v1/saved-policy-filter/${id}`, payload).then(this.handleResponse);
  }

  async remove(id: number): Promise<void> {
    return this.delete<void>(`/v1/saved-policy-filter/${id}`).then(this.handleResponse);
  }
}

export default new SavedPolicyFilterService();
